import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getOverlay} from 'modules/overlay/selectors'
import {setOverlayState} from 'modules/overlay/slice'
import {useRouter} from 'next/router'

import {safelyGetStorageItem} from '@daedalus/core/src/_web/utils/persistence'
import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity
} from '@daedalus/core/src/analytics/types/Events'
import {usePreviousValue} from '@daedalus/core/src/utils/react/hooks/usePreviousValue'
import {parseQueryString} from '@daedalus/core/src/utils/url'

export const getOverlayInfoFromUrlAndStorage = () => {
  const {overlay} = parseQueryString(location.search) as {overlay?: string}
  const overlaysRaw = safelyGetStorageItem(sessionStorage, 'overlays')

  let overlays = []
  try {
    overlays = overlaysRaw ? JSON.parse(overlaysRaw) : []
  } catch (error) {
    console.error('Error hydrating overlay data', error)
  }

  return {
    activeOverlay: overlay || null,
    overlays
  }
}

/**
 * Syncs overlay state from browser history state
 */
export const useSyncOverlayState = () => {
  const dispatch = useDispatch()
  const {query} = useRouter()

  useTrackOverlayClose()

  useEffect(() => {
    const {activeOverlay, overlays} = getOverlayInfoFromUrlAndStorage()

    dispatch(
      setOverlayState({
        overlays,
        activeOverlay
      })
    )
  }, [dispatch, query.overlay])
}

const useTrackOverlayClose = () => {
  const dispatch = useDispatch()
  const overlays = useSelector(getOverlay)
  const prevOverlays = usePreviousValue(overlays)
  useEffect(() => {
    if (prevOverlays && prevOverlays.length > overlays.length) {
      const component = prevOverlays[prevOverlays.length - 1]?.type
      dispatch(
        trackEvent({
          category: Category.System,
          entity: Entity.OverlayClose,
          action: Action.Succeeded,
          component
        })
      )
    }
  }, [dispatch, overlays.length, prevOverlays])
}
